import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Copy trading")
const _hoisted_2 = {
  class: "c-text t-center flex-1",
  style: {"line-height":"24px"}
}
const _hoisted_3 = { class: "mb-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "trader_34" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    cancelText: _withCtx(() => [
      _createVNode(_component_t, {
        path: "trader_39",
        custom: ""
      }, {
        default: _withCtx(({td}) => [
          _createTextVNode(_toDisplayString(td || 'Later'), 1)
        ]),
        _: 1
      })
    ]),
    confirm: _withCtx(() => [
      _createVNode(_component_router_link, {
        custom: "",
        to: "/trade"
      }, {
        default: _withCtx(({navigate}) => [
          _createVNode("button", {
            class: "flex-1 btn primary",
            onClick: ($event: any) => (_ctx.$emit('close', navigate))
          }, [
            _createVNode(_component_t, {
              path: "trader_40",
              custom: ""
            }, {
              default: _withCtx(({td}) => [
                _createTextVNode(_toDisplayString(td || 'View position'), 1)
              ]),
              _: 1
            })
          ], 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Icon, {
          name: "check",
          class: "bg-success mb-8 mt-24",
          style: {"font-size":"40px","color":"white","border-radius":"20px"}
        }),
        _createVNode("p", _hoisted_3, [
          _createVNode(_component_t, {
            path: _ctx.trantext,
            args: {trader: _ctx.prop('traderName', _ctx.order), symbol: _ctx.code, price: _ctx.price}
          }, null, 8, ["path", "args"])
        ])
      ])
    ]),
    _: 1
  }))
}